var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsWidth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0837 20.1364H4.80093C3.47543 20.1364 2.40091 19.0618 2.40093 17.7364L2.40102 8.61205C2.40102 7.69812 2.40068 6.39639 2.40039 5.45384C2.40019 4.79093 2.93752 4.25415 3.60044 4.25415H9.31865L12.0837 7.20779H20.4C21.0627 7.20779 21.6 7.74505 21.6 8.40779V11.5954M19.8 18.7954L21 19.9954M20.4 16.3954C20.4 18.0522 19.0568 19.3954 17.4 19.3954C15.7431 19.3954 14.4 18.0522 14.4 16.3954C14.4 14.7385 15.7431 13.3954 17.4 13.3954C19.0568 13.3954 20.4 14.7385 20.4 16.3954Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsWidth2);
export default __webpack_public_path__ + "static/media/docs-width-2.52eb64bab14c8d2975dfe8c27983cae8.svg";
export { ForwardRef as ReactComponent };